module.exports = new __parcel__URL__("C5O2.da2db7c0.jpeg").toString();